import React from 'react';
import { Button } from '@mui/material';

const ButtonAddBlock = ({ onClick, icon, text }) => (
  <div
    style={{
      padding: '24px 24px 16px 0',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Button
      onClick={onClick}
      variant="contained"
      startIcon={<img src={icon} alt="icon" />}
      style={{
        textTransform: 'none',
        borderRadius: '8px',
        border: '1px solid #1e164e20',
        backgroundColor: '#ffffff',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '-0.4px',
        textAlign: 'center',
        color: '#1e164e',
      }}
    >
      {text}
    </Button>
  </div>
);

export default ButtonAddBlock;
